var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckboxCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3C0 1.34315 1.34315 0 3 0H15ZM13.4697 4.96967L7 11.4393L4.53033 8.96967C4.23744 8.67678 3.76256 8.67678 3.46967 8.96967C3.17678 9.26256 3.17678 9.73744 3.46967 10.0303L6.46967 13.0303C6.76256 13.3232 7.23744 13.3232 7.53033 13.0303L14.5303 6.03033C14.8232 5.73744 14.8232 5.26256 14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967Z",
    fill: "#0B3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxCheck);
export default __webpack_public_path__ + "static/media/icon-checkbox-check.456d55480ff60cb58eecefda02b66eaa.svg";
export { ForwardRef as ReactComponent };